export default __webpack_public_path__ + "static/Borjan-c470eb00f3f29c0125bfa5bf8012a771.jpg";